module.exports = __webpack_public_path__ + "static/vacant-hero-c4d79c66671d4099908571315cb4291e.jpg";